import React from 'react';
import AppRoutes from './routes/routes';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { useAos } from './hooks/useAos';

function App() {
    useAos();

    return (
        <div>
            <AuthProvider>
                <SettingsProvider>
                    <AppRoutes />
                </SettingsProvider>
            </AuthProvider>
        </div>
    );
}

export default App;